import { Injectable } from '@angular/core';
import { NotificationService } from '@progress/kendo-angular-notification';
import { ValidationError } from '../models';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  constructor(private notificationService: NotificationService) {}

  private show(
    message: string,
    type: 'none' | 'success' | 'warning' | 'error' | 'info',
    duration: number = 200,
  ) {
    this.notificationService.show({
      type: { style: type, icon: true },
      animation: { duration: duration },
      content: message,
      position: { horizontal: 'center', vertical: 'top' },
    });
  }

  info(message: string) {
    this.show(message, 'info');
  }

  errorMessage(message: string) {
    this.show(message, 'error');
  }

  error(error: any) {
    if (typeof error === 'string') {
      this.errorMessage(error);
    } else if (
      Array.isArray(error) &&
      error.every((e) => e instanceof ValidationError)
    ) {
      this.validationError(error);
    }
  }

  validationError(validationErrors: ValidationError[]) {
    this.show(
      validationErrors
        .map(
          (validationError) =>
            `${validationError.propertyName}: ${validationError.errorMessage}`,
        )
        .join('\n'),
      'error',
      0,
    );
  }

  success(message: string) {
    this.show(message, 'success');
  }
}
